module.exports = __webpack_public_path__ + "img/mapPicDiploma.0136d70.PNG";